import React, { useState } from 'react';
import api                    from './AxiosConfig';
import { Button, Modal }      from 'react-bootstrap';

const ChangePasswordModal = ({ isOpen, onClose }) => {
  const [message, setMessage] = useState('');
  const [oldPassword,  setOldPassword]  = useState('');
  const [newPassword,  setNewPassword]  = useState('');
  const [newPassword2, setNewPassword2] = useState('');

  const validatePassword = ( password ) => {
      const passwordRegex = /^[\S\\]+$/;
      const digitsRegex   = /^.*[0-9].*$/;
      const specialRegex  = /.*["£%\^\*\(\)\$\&\^\!\-\+\;\:\@\'\#\~\\\/\|\.\,\<\>\?].*/;

      var success = true;
      var msg = "";
      if ( passwordRegex.test(password) !== true ) {
          msg = msg + 'Password contains invalid characters. ';
          success = false;
      }
      if ( password.length < 8 ) {
          msg = msg + 'Password must contain at least 8 characters. ';
          success = false;
      }
      if (digitsRegex.test(password) !== true ){
          msg = msg + 'Password must contain one or more digits. ' ;
          success = false;
      }
      if (specialRegex.test(password) !== true ){
          msg = msg + 'Password must contain one or more of the following special characters "£%^*()$&!-+;:@\'#~\\\/\|.,<>?';
          success = false;
      }
      return { success: success, errmsg: msg };
  }
  
  const handleChangePassword = async () => {
    try {
        if( newPassword !== newPassword2 ){
            setMessage("The new passwords do not match.");
        } else {
            const { success, errmsg } = validatePassword(newPassword);
            if ( !success ) {
                setMessage( errmsg ) 
            } else {
                const response = await api.post('/site/login/change-password', { oldPassword: oldPassword, newPassword: newPassword }, { withCredentials: true } );
                if (response.status === 200) {
                    onClose();
                } else {
                    setMessage( response.data.message );
                }
            }
        }
    } catch (error) {
        console.error('Change Passowrd error:', error);
        setMessage(error.response.data.message);
    }

  };

  if (!isOpen) return null; // Don't render the modal if it's not open

  return (
    <Modal show={ true } backdrop="static">
      <Modal.Header>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>Old Password
        <input
          type="password"
          placeholder="oldPassword"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
        />
            New Password
        <input
          type="password"
          placeholder="newPassword"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
            Repeat New Password
        <input
          type="password"
          placeholder="newPassword2"
          value={newPassword2}
          onChange={(e) => setNewPassword2(e.target.value)}
        />
        </form>
        <Button variant="primary" size="sm" onClick={handleChangePassword}>Change Password</Button>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" size="sm" onClick={onClose}>Cancel</Button>
        <p>{ message }</p>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePasswordModal;
